export default __webpack_public_path__ + "static/media/leader_notes.b082570c.pdf";